import { observable } from 'mobx'

/**
 * Info about the application.
 */
export interface ShellInfo {
  /**
   * The name of the application, which is the current workspace's name.
   */
  readonly name: string

  /**
   * URL for the main icon.
   */
  readonly iconUrl: string

  /**
   * URL for the main icon, but for use on inverted (dark) surfaces.
   */
  readonly invertedIconUrl: string

  /**
   * URL for the main logo.
   */
  readonly logoUrl: string

  /**
   * URL for the image shown beside the sign-in and email confirmation views.
   */
  readonly landingPageImageUrl: string

  /**
   * Whether the workspace wants a corporate look, which hides illustrations.
   */
  readonly corporateMode: boolean
}

/**
 * Creates a reactive {@link ShellInfo}.
 */
export function ShellInfo(getter: () => ShellInfo) {
  return observable<ShellInfo>({
    get name() {
      return getter().name
    },
    get iconUrl() {
      return getter().iconUrl
    },
    get invertedIconUrl() {
      return getter().invertedIconUrl
    },
    get logoUrl() {
      return getter().logoUrl
    },
    get landingPageImageUrl() {
      return getter().landingPageImageUrl
    },
    get corporateMode() {
      return getter().corporateMode
    },
  })
}
